$( document ).ready(function() {
  $('#Slide-template--22126972567877__slideshow_JTfDcp-1').append(
    '<div class="logoSlider">' +
                    '<img src="https://cdn.shopify.com/s/files/1/0863/3342/3941/files/logo_tbm_blanc.png?v=1719914817" alt="logo TBM">' +
                '</div>'
  )
  $('#Slide-template--22126972567877__slideshow_JTfDcp-2').append(
    '<div class="logoSlider">' +
                    '<img src="https://cdn.shopify.com/s/files/1/0863/3342/3941/files/logo_kodiak_en_noir.png?v=1718625732" alt="logo Kodiak">' +
                '</div>'
  )
  $('#Slide-template--22126972567877__slideshow_JTfDcp-3').append(
    '<div class="logoSlider">' +
                    '<img src="https://cdn.shopify.com/s/files/1/0863/3342/3941/files/logo_tbmkodiak.png?v=1718625732" alt="logo TBM et Kodiak">' +
                '</div>'
  )


  
});




